export type RecaptchaExecutor = (action: string) => Promise<string>;

export type RecaptchaFailureReason = "not-loaded" | "failed";

export type RecaptchaTokenResult =
  | { ok: true; token: string }
  | { ok: false; reason: RecaptchaFailureReason };

export const waitForRecaptchaExecutor = async (
  readExecutor: () => RecaptchaExecutor | undefined,
  { attempts, sleep }: { attempts: number; sleep: () => Promise<unknown> }
): Promise<RecaptchaExecutor | undefined> => {
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    const executor = readExecutor();

    if (executor) {
      return executor;
    }

    await sleep();
  }

  return readExecutor();
};

export const recaptchaErrorText = (reason: RecaptchaFailureReason): string =>
  reason === "not-loaded"
    ? "reCAPTCHA could not load. Turn off your ad blocker or browser shields for this site, then reload the page."
    : "reCAPTCHA verification failed. Please try again.";
